import { Link, ModuleBase } from '@/components';
import { LinkModel, ModuleBaseModel, ModuleBasePropsModel } from '@/types';
import { isColorDark, lightenDarkenColor } from '@/utils';
import { useMemo } from 'react';

type PullStatModuleModel = ModuleBaseModel<
  {
    description: string;
    link?: LinkModel;
    numericValue: string;
  } & ModuleBasePropsModel
>;

const PullStatModule = (data: PullStatModuleModel) => {
  const {
    props: { description, link, numericValue, backgroundColour },
  } = data;

  const textHighlightColour = useMemo(() => {
    switch (backgroundColour) {
      case '#e6eeec':
        return '#cfdedb';
      case '#ece3d6':
        return '#dacab3';
      case '#f3e5dc':
        return '#e8cebf';
    }

    const bkClr = backgroundColour || '#000000';
    const isDark = isColorDark(bkClr);
    let rv;

    if (isDark)
      // if there is no backgroundColor lighten the #000 to get a grey else lighten by 20%
      rv = lightenDarkenColor(bkClr, !backgroundColour ? 180 : 20);
    // this is light background and lighten the quote sign by 20%
    else rv = lightenDarkenColor(bkClr, 20);

    return rv;
  }, [backgroundColour]);

  return (
    <ModuleBase data={{ ...data, props: { ...data.props } }} noPadding className="py-8 xl:py-16">
      <div className="relative z-10 container px-7 pt-0 pb-0 md:px-[100px] lg:px-9 print:hidden">
        <div
          className="absolute top-0 z-[-1] text-[120px] leading-[120px] font-semibold xl:text-[200px] xl:leading-[140px]"
          style={{ color: textHighlightColour }}
        >
          {numericValue}
        </div>
        <div className="flex flex-col items-end pt-14 pb-6">
          <div className="w-full md:w-9/12 lg:w-10/12">
            <h2 className="color-from-bg text-[22px] leading-7 font-light xl:text-[40px] xl:leading-[48px]">
              {description}
            </h2>
            {link && (
              <Link link={link} className="btn btn-from-bg text !text-xs !leading-[18px] !font-semibold underline">
                {link.text || 'Link'}
              </Link>
            )}
          </div>
        </div>
      </div>
    </ModuleBase>
  );
};

export default PullStatModule;
